import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';


export const useDeleteWarehouse = (lcrId) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(
    (payload) => axiosInstance.delete(liveCleanroom(orgId)
      .deleteWarehouse(lcrId, payload.warehouseId)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['warehouseList', lcrId] });
        dispatch(showAlert({
          message: 'Warehouse deleted successfully',
          type: 'success',
        }));
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error deleting warehouse',
            type: 'error',
          }),
        );
      },
    },
  );
};
